const MSG_HEAD_SIZE = 20;     // 报文尾大小
const MSG_STX = 0xAA55;       //结束位

const NotifyMsgHeader = function(opts = {}) {
    this.stx        = opts.stx        || MSG_STX;  // 起始位（2字节）
    this.version    = opts.version    || 0;        // 版本号（2字节），目前为 0
    this.dataSize   = opts.dataSize   || 0;        // 块数据的总长度（4字节）
    this.blockCount = opts.blockCount || 0;        // 块数量（4字节）
    this.cmd        = opts.cmd        || 0;        // 指令（2字节）
    this.cmdParam   = opts.cmdParam   || 0;        // 指令参数（2字节）
    this.reserv     = opts.reserv     || 0;        // 保留位（4字节）
};

NotifyMsgHeader.MSG_HEAD_SIZE   = MSG_HEAD_SIZE;
NotifyMsgHeader.MSG_STX         = MSG_STX;

const pt = NotifyMsgHeader.prototype;

// 写入数据块
pt.writeHeader = function(writer) {
    writer.writeInt16(this.stx);
    writer.writeInt16(this.version);
    writer.writeInt32(this.dataSize);
    writer.writeInt32(this.blockCount);
    writer.writeInt16(this.cmd);
    writer.writeInt16(this.cmdParam);
    writer.writeInt32(this.reserv);
};

pt.readHeader = function (reader) {
    let header = this;
    header.stx = reader.readInt16();
    header.version = reader.readInt16();
    header.dataSize = reader.readInt32();
    header.blockCount = reader.readInt32();
    header.cmd = reader.readInt16();
    header.cmdParam = reader.readInt16();
    header.reserv = reader.readInt32();
};

NotifyMsgHeader.parseFromReader = function (reader) {
    var header = new NotifyMsgHeader();
    header.readHeader(reader);
    return header;
};

export default NotifyMsgHeader;
